module.exports = __webpack_public_path__ + "static/img/yytx.360cdda.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fresh/yytx.png
// module id = Ijwu
// module chunks = 1